function replaceTaxText() {
    const taxSpans = document.querySelectorAll('.b2b-nt-cart-tax-price span:last-child');
    
    taxSpans.forEach(el => {
        if (el.textContent.includes('Included') || el.textContent.includes('included')) {
            el.innerHTML = el.innerHTML.replace(/Included|included/g, 'inkl.');
        }
    });
}

const observer = new MutationObserver((mutations) => {
    replaceTaxText();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

replaceTaxText();